import { render, staticRenderFns } from "./RedirectToDiscountPopup.vue?vue&type=template&id=5820749b&scoped=true&"
import script from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
export * from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedirectToDiscountPopup.vue?vue&type=style&index=0&id=5820749b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820749b",
  null
  
)

export default component.exports